var FIT_GUIDE_EQUIVALENCES = {
    '80A': '75 B',
    '85A': '80 B',
    '90A': '85 B',
    '95A': '90 B',
    '100A': '95 B',
    '105A' : '100 B',
    '110A' : '105 B',
    '115A' : '110 B',
    '120A' : '115 B',
    '80B': '85 A',
    '80D': '85 C',
    '80E': '85 D',
    '80F': '85 E',
    '85B': '',
    '85C': '90 B',
    '85D': '90 C',
    '85E': '90 D',
    '85F': '90 E',
    '90B': '85 C',
    '90C': '95 B',
    '90D': '95 C',
    '90E': '95 D',
    '90F': '95 E',
    '95B': '90 C',
    '95C': '100 B',
    '95D': '100 C',
    '95E': '100 D',
    '100B': '95 C',
    '100C': '105 B',
    '100D': '105 C'
};

var FIT_GUIDE_EQUIVALENCES_BRA_REGIONS = {
    '80': {
        'eur': 65,
        'usa': 30
    },
    '85': {
        'eur': 70,
        'usa': 32
    },
    '90': {
        'eur': 75,
        'usa': 34
    },
    '95': {
        'eur': 80,
        'usa': 36
    },
    '100': {
        'eur': 85,
        'usa': 38
    },
    '105': {
        'eur': 90,
        'usa': 40
    },
    '110': {
        'eur': 95,
        'usa': 42
    }
};
const FIT_GUIDE_EQUIVALENCES_BODY_REGIONS = {
    '75': {
        'ita': 1,
        'eur': 60
    },
    '80':{
        'ita':2,
        'eur':65
    },
    '85':{
        'ita':3,
        'eur':70
    },
    '90':{
        'ita':4,
        'eur':75
    },
    '95':{
        'ita':5,
        'eur':80
    },
    '100':{
        'ita':6,
        'eur':85
    },
    '105':{
        'ita':7,
        'eur':90
    },
    '110':{
        'ita':8,
        'eur':95
    },
    '115':{
        'ita':9,
        'eur':100
    },
    '120':{
        'ita':10,
        'eur':105
    }
}

const FIT_GUIDE_EQUIVALENCES_SHOE_REGIONS = {
    '37/38': {
        'eu': '37/38',
        'size': 'S'
    },
    '39/40': {
        'eu': '39/40',
        'size': 'M'
    },
    '41/42': {
        'eu': '41/42',
        'size': 'L'
    }
}

const FIT_GUIDE_EQUIVALENCES_SWIM_PLUS_REGIONS = {
    '42': {
        'ita': 46
    },
    '44': {
        'ita': 48
    },
    '46': {
        'ita': 50
    },
    '48': {
        'ita': 52
    },
    '50': {
        'ita': 54
    },
    '52': {
        'ita': 56
    }
}

const FIT_GUIDE_EQUIVALENCES_SWIM_WO_CUP_REGIONS = {
    'S': {
        'es_eu': '85 – 90',
        'ita': '1 – 2',
        'fr': '70 – 75',
        'uk_us': '32 – 34'
    },
    'M': {
        'es_eu': '90 – 95',
        'ita': '2 – 3',
        'fr': '75 – 80',
        'uk_us': '34 – 36'
    },
    'L': {
        'es_eu': '95 – 100',
        'ita': '3 – 4',
        'fr': '80 – 85',
        'uk_us': '36 – 38'
    },
    'XL': {
        'es_eu': '100 – 105',
        'ita': '4 – 5',
        'fr': '85 – 90',
        'uk_us': '38 – 40'
    }
}

const FIT_GUIDE_EQUIVALENCES_KIDS_PAJAMA_REGIONS = {
    '4-5': {
        'es_eu': '110',
        'ita': '110',
        'fr': '5',
        'uk_us': '4-5'
    },
    '6-7': {
        'es_eu': '122',
        'ita': '122',
        'fr': '7',
        'uk_us': '6-7'
    },
    '8-9': {
        'es_eu': '134',
        'ita': '134',
        'fr': '9',
        'uk_us': '8-9'
    },
    '10-11': {
        'es_eu': '146',
        'ita': '146',
        'fr': '11',
        'uk_us': '10-11'
    },
    '12-13': {
        'es_eu': '158',
        'ita': '158',
        'fr': '13',
        'uk_us': '12-13'
    }
}

var braRegion = 'es';
let recommendedSize = null;

document.addEventListener("DOMContentLoaded", function () {

    const openBtns = document.querySelectorAll('.open-size-guide, #open-size-guide');
    const stickyInfo = document.querySelector('safe-sticky.product-info');

    function movePanelToBody(panel) {
        return;
    }

    function restorePanel(panel) {
        return;
    }

    function runInitializers(panel) {
        if (!panel || panel.dataset.initialized === 'true') {
            try { updateBraResult?.(); } catch(e) {}
            try { updateBraWoCupResult?.(); } catch(e) {}
            try { updateKnickersResult?.(); } catch(e) {}
            try { updateBodyResult?.(); } catch(e) {}
            try { updateSwimResult?.(); } catch(e) {}
            try { updateDressResult?.(); } catch(e) {}
            try { updateRobeResult?.(); } catch(e) {}
            try { updateShortsResult?.(); } catch(e) {}
            try { updatePajamaResult?.(); } catch(e) {}
            try { updateKidsPajamaResult?.(); } catch(e) {}
            try { updateShoeResult?.(); } catch(e) {}
            return;
        }
        const guide = panel.querySelector('#size-guide-content');
        if (!guide || !guide.dataset.guideType) return;
        const type = guide.dataset.guideType;

        if (type === 'bra') {
            const breastInput = panel.querySelector('#braChest');
            const underBreastInput = panel.querySelector('#braLowChest');
            if (breastInput && underBreastInput) {
                breastInput.addEventListener('input', updateBraResult);
                underBreastInput.addEventListener('input', updateBraResult);
                updateBraResult();
            }
            panel.querySelectorAll('.region-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    const region = btn.dataset.region;
                    changeBraResultRegion(region);
                });
            });
        } else if (type === 'bra-wo-cup') {
            const breastInput = panel.querySelector('#braChest');
            const underBreastInput = panel.querySelector('#braLowChest');
            if (breastInput && underBreastInput) {
                breastInput.addEventListener('input', updateBraWoCupResult);
                underBreastInput.addEventListener('input', updateBraWoCupResult);
                updateBraWoCupResult();
            }
        } else if (type === 'knickers') {
            const waistInput = panel.querySelector('#pantiesWaist');
            const hipInput = panel.querySelector('#pantiesHip');
            if (waistInput && hipInput) {
                waistInput.addEventListener('input', updateKnickersResult);
                hipInput.addEventListener('input', updateKnickersResult);
                updateKnickersResult();
            }
        } else if (type === 'shorts') {
            const waistInput = panel.querySelector('#shortsWaist');
            const hipInput = panel.querySelector('#shortsHip');
            if (waistInput && hipInput) {
                waistInput.addEventListener('input', updateShortsResult);
                hipInput.addEventListener('input', updateShortsResult);
                updateShortsResult();
            }
        } else if (type === 'vestidos') {
            const breastInput = panel.querySelector('#dressBreast');
            const waistInput = panel.querySelector('#dressWaist');
            const hipInput = panel.querySelector('#dressHip');
            if (breastInput && waistInput && hipInput) {
                breastInput.addEventListener('input', updateDressResult);
                waistInput.addEventListener('input', updateDressResult);
                hipInput.addEventListener('input', updateDressResult);
                updateDressResult();
            }
        } else if (type === 'batas') {
            const breastInput = panel.querySelector('#batasBreast');
            const waistInput = panel.querySelector('#batasWaist');
            const hipInput = panel.querySelector('#batasHip');
            if (breastInput && waistInput && hipInput) {
                breastInput.addEventListener('input', updateRobeResult);
                waistInput.addEventListener('input', updateRobeResult);
                hipInput.addEventListener('input', updateRobeResult);
                updateRobeResult();
            }
        } else if (type === 'body') {
            const breastInput = panel.querySelector('#bodyChest');
            const underBreastInput = panel.querySelector('#bodyLowChest');
            if (breastInput && underBreastInput) {
                breastInput.addEventListener('input', updateBodyResult);
                underBreastInput.addEventListener('input', updateBodyResult);
                updateBodyResult();
            }
            panel.querySelectorAll('.region-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    const region = btn.dataset.region;
                    changeBodyResultRegion(region);
                });
            });
        } else if (type === 'swim') {
            const breastInput = panel.querySelector('#swimChest');
            const underBreastInput = panel.querySelector('#swimLowChest');
            if (breastInput && underBreastInput) {
                breastInput.addEventListener('input', updateSwimResult);
                underBreastInput.addEventListener('input', updateSwimResult);
                updateSwimResult();
            }
            panel.querySelectorAll('.region-btn').forEach(btn => {
                btn.addEventListener('click', () => {
                    const region = btn.dataset.region;
                    changeBraResultRegion(region);
                });
            });
        } else if (type === 'women-pajamas') {
            const breastInput = panel.querySelector('#pajamasBreast');
            const waistInput = panel.querySelector('#pajamasWaist');
            const hipInput = panel.querySelector('#pajamasHip');
            if (breastInput && waistInput && hipInput) {
                breastInput.addEventListener('input', updatePajamaResult);
                waistInput.addEventListener('input', updatePajamaResult);
                hipInput.addEventListener('input', updatePajamaResult);
                updatePajamaResult();
            }
        } else if (type === 'kids-pajamas') {
            const kidsInput = panel.querySelector('#kidsPajamasAge');
            if (kidsInput) {
                kidsInput.addEventListener('change', updateKidsPajamaResult);
                updateKidsPajamaResult();
            }
        } else if (type === 'zapatillas') {
            const shoeInput = panel.querySelector('#shoeSize');
            if (shoeInput) {
                shoeInput.addEventListener('change', updateShoeResult);
                updateShoeResult();
            }
        }
        panel.dataset.initialized = 'true';
    }

    function openPanel(localPanel) {
        movePanelToBody(localPanel);
        localPanel.classList.remove('hidden');
        document.body.classList.add('body-no-scroll');
        setTimeout(() => {
            localPanel.classList.add('active');
            if (stickyInfo) stickyInfo.style.zIndex = '99';
            runInitializers(localPanel);
        }, 10);
    }

    function closePanel(localPanel) {
        localPanel.classList.remove('active');
        document.body.classList.remove('body-no-scroll');
        setTimeout(() => {
            localPanel.classList.add('hidden');
            if (stickyInfo) stickyInfo.style.zIndex = '';
            restorePanel(localPanel);
        }, 300);
    }

    openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const root = btn.closest('.size-picker') || document;
            const localPanel = root.querySelector('.size-guide-panel');
            if (!localPanel) return;
            openPanel(localPanel);
        });
    });

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.open-size-guide, #open-size-guide');
        if (!trigger) return;
        event.preventDefault();
        const root = trigger.closest('.size-picker') || document;
        const localPanel = root.querySelector('.size-guide-panel');
        if (!localPanel) return;
        openPanel(localPanel);
    });

    document.addEventListener('click', (event) => {
        const closeButton = event.target.closest('#close-size-guide');
        if (!closeButton) return;
        const localPanel = closeButton.closest('.size-guide-panel');
        if (!localPanel) return;
        closePanel(localPanel);
    });

    document.addEventListener('click', (event) => {
        if (!event.target.classList || !event.target.classList.contains('size-guide-panel')) return;
        const localPanel = event.target;
        closePanel(localPanel);
    });

    const guide = document.getElementById('size-guide-content');

    if (!guide || !guide.dataset.guideType) {
        openBtns.forEach(btn => {
            btn.style.display = 'none';
        });
        return;
    }

    const type = guide.dataset.guideType;

    if (type === 'bra') {
        const breastInput = document.getElementById('braChest');
        const underBreastInput = document.getElementById('braLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateBraResult);
            underBreastInput.addEventListener('input', updateBraResult);
            updateBraResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeBraResultRegion(region);
            });
        });
    }else if(type === 'bra-wo-cup'){
        const breastInput = document.getElementById('braChest');
        const underBreastInput = document.getElementById('braLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateBraWoCupResult);
            underBreastInput.addEventListener('input', updateBraWoCupResult);
            updateBraWoCupResult();
        }
    }else if(type === 'knickers'){
        const waistInput = document.getElementById('pantiesWaist');
        const hipInput = document.getElementById('pantiesHip');

        if (waistInput && hipInput){
            waistInput.addEventListener('input',updateKnickersResult)
            hipInput.addEventListener('input',updateKnickersResult)
            updateKnickersResult()
        }
    }else if(type === 'shorts'){
        const waistInput = document.getElementById('shortsWaist');
        const hipInput = document.getElementById('shortsHip');

        if(waistInput && hipInput){
            waistInput.addEventListener('input', updateShortsResult);
            hipInput.addEventListener('input', updateShortsResult);
            updateShortsResult();
        }
    }else if(type === 'vestidos'){
        const breastInput = document.getElementById('dressBreast');
        const waistInput = document.getElementById('dressWaist');
        const hipInput = document.getElementById('dressHip');

        if(breastInput && waistInput && hipInput){
            breastInput.addEventListener('input', updateDressResult);
            waistInput.addEventListener('input', updateDressResult);
            hipInput.addEventListener('input', updateDressResult);
            updateDressResult();
        }
    }else if(type === 'batas'){
        const breastInput = document.getElementById('batasBreast');
        const waistInput = document.getElementById('batasWaist');
        const hipInput = document.getElementById('batasHip');

        if(breastInput && waistInput && hipInput){
            breastInput.addEventListener('input', updateRobeResult);
            waistInput.addEventListener('input', updateRobeResult);
            hipInput.addEventListener('input', updateRobeResult);
            updateRobeResult();
        }
    }else if(type === 'body'){
        const breastInput = document.getElementById('bodyChest');
        const underBreastInput = document.getElementById('bodyLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateBodyResult);
            underBreastInput.addEventListener('input', updateBodyResult);
            updateBodyResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeBodyResultRegion(region);
            });
        });

    }else if(type === 'swim'){
        const breastInput = document.getElementById('swimChest');
        const underBreastInput = document.getElementById('swimLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateSwimResult);
            underBreastInput.addEventListener('input', updateSwimResult);
            updateSwimResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeSwimResultRegion(region);
            });
        });
    }else if(type === 'swim-wo-cup'){
        const breastInput = document.getElementById('swimWoCupChest');
        const underBreastInput = document.getElementById('swimWoCupLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateSwimWoCupResult);
            underBreastInput.addEventListener('input', updateSwimWoCupResult);
            updateSwimWoCupResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeSwimWoCupResultRegion(region);
            });
        });
    }else if(type === 'women-pajama'){
        const breastInput = document.getElementById('pajamasBreast');
        const waistInput = document.getElementById('pajamasWaist');
        const hipInput = document.getElementById('pajamasHip');

        if (breastInput && waistInput && hipInput) {
            breastInput.addEventListener('input', updatePajamaResult);
            waistInput.addEventListener('input', updatePajamaResult);
            hipInput.addEventListener('input', updatePajamaResult);
            updatePajamaResult();
        }
    }else if(type === 'tshirt'){
        const breastInput = document.getElementById('tshirtBreast');
        const waistInput = document.getElementById('tshirtWaist');

        if (breastInput && waistInput) {
            breastInput.addEventListener('input', updateTShirtResult);
            waistInput.addEventListener('input', updateTShirtResult);
            updateTShirtResult();
        }
    }else if(type === 'zapatillas'){
        const shoeLengthInput = document.getElementById('shoeLength');

        if (shoeLengthInput) {
            shoeLengthInput.addEventListener('input', updateShoeResult);
            updateShoeResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeShoeResultRegion(region);
            });
        });
    }else if(type === 'underwear'){
        const waistInput = document.getElementById('underwearWaist');
        const hipInput = document.getElementById('underwearHip');

        if(waistInput && hipInput){
            waistInput.addEventListener('input', updateUnderwearResult);
            hipInput.addEventListener('input', updateUnderwearResult);
            updateUnderwearResult();
        }
    }else if(type === 'swim-plus-size'){
        const breastInput = document.getElementById('swimPlusBreast');
        const waistInput = document.getElementById('swimPlusWaist');
        const hipInput = document.getElementById('swimPlusHip');

        if(breastInput && waistInput && hipInput){
            breastInput.addEventListener('input', updateSwimPlusResult);
            waistInput.addEventListener('input', updateSwimPlusResult);
            hipInput.addEventListener('input', updateSwimPlusResult);
            updateSwimPlusResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeSwimPlusResultRegion(region);
            });
        });
    }else if(type === 'men-pajama'){
        const breastInput = document.getElementById('menPajamasBreast');
        const waistInput = document.getElementById('menPajamasWaist');
        const hipInput = document.getElementById('menPajamasHip');

        if(breastInput && waistInput && hipInput){
            breastInput.addEventListener('input', updateMenPajamaResult);
            waistInput.addEventListener('input', updateMenPajamaResult);
            hipInput.addEventListener('input', updateMenPajamaResult);
            updateMenPajamaResult();
        }
    }else if(type === 'body-wo-cup'){
        const breastInput = document.getElementById('bodyWoCupChest');
        const underBreastInput = document.getElementById('bodyWoCupLowChest');

        if (breastInput && underBreastInput) {
            breastInput.addEventListener('input', updateBodyWoCupResult);
            underBreastInput.addEventListener('input', updateBodyWoCupResult);
            updateBodyWoCupResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeBodyWoCupResultRegion(region);
            });
        });
    }else if(type === 'kids-pajama'){
        const heightInput = document.getElementById('kidsPajamaHeight');
        const chestInput = document.getElementById('kidsPajamaChest');
        const waistInput = document.getElementById('kidsPajamaWaist');
        const hipInput = document.getElementById('kidsPajamaHip');

        if (heightInput && chestInput && waistInput && hipInput) {
            heightInput.addEventListener('input', updateKidsPajamaResult);
            chestInput.addEventListener('input', updateKidsPajamaResult);
            waistInput.addEventListener('input', updateKidsPajamaResult);
            hipInput.addEventListener('input', updateKidsPajamaResult);
            updateKidsPajamaResult();
        }

        document.querySelectorAll('.region-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const region = btn.dataset.region;
                changeKidsPajamaResultRegion(region);
            });
        });
    }
    initSizeGuideAddToCart()
});

function outputSliderValue(slider, value) {
    const wrapper = slider.closest('.slider-wrapper');
    if (!wrapper) return;
    const valueEl = wrapper.querySelector('.discover-value');
    if (valueEl) {
        if (slider.id === 'shoeLength') {
            const formattedValue = typeof value === 'string' && value.includes('.') 
                ? value 
                : parseFloat(value).toFixed(1);
            valueEl.textContent = formattedValue + ' CM';
        } else {
            valueEl.textContent = value + ' CM';
        }
    }
}


function setBraSliderValue(slider, value)
{
    outputSliderValue(slider, value);
    showBraResult(braRegion);
}

function extractNumber(string)
{
    var regex = /(\d+)/g;
    var results = string.match(regex);
    return results!=null ? results[0] : '?';
}

function changeBraResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('braResult','braEquivalence');
}

function calculateBraSizeWithApproachIfNeeded(breast1, breast2)
{

    var value = calculateBraSize(breast1, breast2);
    var maximumRetries = 20;
    var breast1SliderScore = (121 - 72) - (121 - breast1);
    var breast2SliderScore = (107 - 58) - (107 - breast2);
    while(value == '' && maximumRetries > 0) {
        if(breast1SliderScore > breast2SliderScore) {
            breast1--;
        } else {
            breast1++;
        }
        value = calculateBraSize(breast1, breast2);
        maximumRetries--;
    }
    return value;
}
function calculateBraWoCupSizeWithApproachIfNeeded(breast1, breast2)
{

    var value = calculateBraWoCupSize(breast1, breast2);
    var maximumRetries = 8;
    var breast1SliderScore = (103 - 85) - (103 - breast1);
    var breast2SliderScore = (87 - 68) - (87 - breast2);
    while(value == '' && maximumRetries > 0) {
        if(breast1SliderScore > breast2SliderScore) {
            breast1--;
        } else {
            breast1++;
        }
        value = calculateBraWoCupSize(breast1, breast2);
        maximumRetries--;
    }
    return value;
}

function calculateKnickerSizeWithApproachIfNeeded(waist,hip)
{
    let value = calculateKnickersSize(waist, hip);
    let maximumRetries = 50;
    let waistSliderScore = (100 - 61) - (100 - waist);
    let hipSliderScore = (120 - 87) - (120 - hip);
    while(value == '' && maximumRetries > 0) {
        if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateKnickersSize(waist, hip);
        maximumRetries--;
    }
    return value;
}


function calculateBraSize(breast1, breast2)
{
    // breast1: pecho - contorno busto
    // breast2: bajo pecho - contorno torax
    if(breast2 >= 58 && breast2 <= 62){
        if(breast1 >= 72 && breast1 <= 75){
            return '75A';
        } else if(breast1 >= 74 && breast1 <= 76) {
            return '75B';
        }
    } else if(breast2 >= 63 && breast2 <= 67){
        if(breast1 >= 77 && breast1 < 79){
            return '80A';
        } else if(breast1 >= 79 && breast1 <= 81) {
            return '80B';
        } else if(breast1 > 81 && breast1 <= 83) {
            return '80C';
        } else if(breast1 > 83 && breast1 <= 85) {
            return '80D';
        }
    } else if(breast2 >= 68 && breast2 <= 72){
        if(breast1 >= 82 && breast1 < 84){
            return '85A';
        } else if(breast1 >= 84 && breast1 <= 86) {
            return '85B';
        } else if(breast1 > 86 && breast1 <= 88) {
            return '85C';
        } else if(breast1 > 88 && breast1 <= 90) {
            return '85D';
        } else if(breast1 > 90 && breast1 <= 92) {
            return '85E';
        } else if(breast1 > 92 && breast1 <= 94) {
            return '85F';
        }
    } else if(breast2 >= 73 && breast2 <= 77){
        if(breast1 >= 87 && breast1 < 89){
            return '90A';
        } else if(breast1 >= 89 && breast1 <= 91) {
            return '90B';
        } else if(breast1 > 91 && breast1 <= 93) {
            return '90C';
        } else if(breast1 > 93 && breast1 <= 95) {
            return '90D';
        } else if(breast1 > 95 && breast1 <= 97) {
            return '90E';
        } else if(breast1 > 97 && breast1 <= 99) {
            return '90F';
        }
    } else if(breast2 >= 78 && breast2 <= 82){
        if(breast1 >= 92 && breast1 < 94){
            return '95A';
        } else if(breast1 >= 94 && breast1 <= 96) {
            return '95B';
        } else if(breast1 > 96 && breast1 <= 98) {
            return '95C';
        } else if(breast1 > 98 && breast1 <= 100) {
            return '95D';
        } else if(breast1 > 100 && breast1 <= 102) {
            return '95E';
        } else if(breast1 > 102 && breast1 <= 104) {
            return '95F';
        }
    } else if(breast2 >= 83 && breast2 <= 87){
        if(breast1 >= 97 && breast1 < 99) {
            return '100A';
        } else if(breast1 >= 99 && breast1 <= 101) {
            return '100B';
        } else if(breast1 > 101 && breast1 <= 103) {
            return '100C';
        } else if(breast1 > 103 && breast1 <= 105) {
            return '100D';
        } else if(breast1 > 105 && breast1 <= 107) {
            return '100E';
        } else if(breast1 > 107 && breast1 <= 109) {
            return '100F';
        }
    } else if(breast2 >= 88 && breast2 <= 92){
        if(breast1 >= 102 && breast1 < 104) {
            return '105A';
        } else if(breast1 >= 104 && breast1 <= 106) {
            return '105B';
        } else if(breast1 > 106 && breast1 <= 108) {
            return '105C';
        } else if(breast1 > 108 && breast1 <= 110) {
            return '105D';
        } else if(breast1 > 110 && breast1 <= 112) {
            return '105E';
        } else if(breast1 > 112 && breast1 <= 114) {
            //return '105F';
        }
    } else if(breast2 >= 93 && breast2 <= 97){
        if(breast1 >= 107 && breast1 < 109) {
            return '110A';
        } else if(breast1 >= 109 && breast1 <= 111) {
            return '110B';
        } else if(breast1 > 111 && breast1 <= 113) {
            return '110C';
        } else if(breast1 > 113 && breast1 <= 115) {
            return '110D';
        } else if(breast1 > 115 && breast1 <= 117) {
            //return '110E';
        } else if(breast1 > 117 && breast1 <= 119) {
            //return '110F';
        }
    } else if(breast2 >= 98 && breast2 <= 102){
        if(breast1 >= 112 && breast1 <= 113) {
            return '115A';
        } else if(breast1 >= 114 && breast1 <= 116) {
            return '115B';
        } else if(breast1 > 116 && breast1 <= 118) {
            return '115C';
        } else if(breast1 > 118 && breast1 <= 120) {
            //return '115D';
        } else if(breast1 > 120 && breast1 <= 122) {
            //return '115E';
        } else if(breast1 > 122 && breast1 <= 124) {
            //return '115F';
        }
    } else if(breast2 >= 103 && breast2 <= 107){
        if(breast1 >= 117 && breast1 < 119) {
            return '120A';
        } else if(breast1 >= 119 && breast1 <= 121) {
            return '120B';
        } else if(breast1 > 121 && breast1 <= 123) {
            //return '120C';
        } else if(breast1 > 123 && breast1 <= 125) {
            //return '120D';
        } else if(breast1 > 125 && breast1 <= 127) {
            //return '120E';
        } else if(breast1 > 127 && breast1 <= 129) {
            //return '120F';
        }
    }
    return '';
}

function calculateBraWoCupSize(breast1, breast2)
{
    // breast1: pecho - contorno busto
    // breast2: bajo pecho - contorno torax
    if(breast2 >= 68 && breast2 <= 72){
        if(breast1 >= 85 && breast1 <= 88){
            return 'S';
        }
    } else if(breast2 >= 73 && breast2 <= 77){
        if(breast1 >= 89 && breast1 <= 93){
            return 'M';
        }
    } else if(breast2 >= 78 && breast2 <= 82){
        if(breast1 >= 94 && breast1 <= 98){
            return 'L';
        }
    } else if(breast2 >= 83 && breast2 <= 87){
        if(breast1 >= 98 && breast1 <= 103){
            return 'XL';
        }
    }
    return '';
}

function updateBraResult() {
    const breastInput = document.getElementById('braChest');
    const underBreastInput = document.getElementById('braLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('braResult','braEquivalence');
}
function updateBraWoCupResult() {
    const breastInput = document.getElementById('braChest');
    const underBreastInput = document.getElementById('braLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraWoCupSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('braResult','braEquivalence');
}

function updateKnickersResult() {
    const waistInput = document.getElementById('pantiesWaist');
    const hipInput = document.getElementById('pantiesHip');

    if (!waistInput || !hipInput) return;

    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);
    recommendedSize = calculateKnickerSizeWithApproachIfNeeded(waist, hip);

    renderResult('pantiesResult','pantiesEquivalence');
}

function updateBodyResult() {
    const breastInput = document.getElementById('bodyChest');
    const underBreastInput = document.getElementById('bodyLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('bodyResult','bodyEquivalence');
}

function changeBodyResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('bodyResult','bodyEquivalence');
}

function updateSwimResult() {
    const breastInput = document.getElementById('swimChest');
    const underBreastInput = document.getElementById('swimLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('swimResult','swimEquivalence');
}

function changeSwimResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('swimResult','swimEquivalence');
}

function updateSwimWoCupResult() {
    const breastInput = document.getElementById('swimWoCupChest');
    const underBreastInput = document.getElementById('swimWoCupLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraWoCupSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('swimWoCupResult','swimWoCupEquivalence');
}

function changeSwimWoCupResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('swimWoCupResult','swimWoCupEquivalence');
}

function updateBodyWoCupResult() {
    const breastInput = document.getElementById('bodyWoCupChest');
    const underBreastInput = document.getElementById('bodyWoCupLowChest');

    if (!breastInput || !underBreastInput) return;

    const breast = parseInt(breastInput.value, 10);
    const underBreast = parseInt(underBreastInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(underBreastInput, underBreast);

    recommendedSize = calculateBraWoCupSizeWithApproachIfNeeded(breast, underBreast);

    renderResult('bodyWoCupResult','bodyWoCupEquivalence');
}

function changeBodyWoCupResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('bodyWoCupResult','bodyWoCupEquivalence');
}

function updatePajamaResult() {
    const breastInput = document.getElementById('pajamasBreast');
    const waistInput = document.getElementById('pajamasWaist');
    const hipInput = document.getElementById('pajamasHip');

    if (!breastInput || !waistInput || !hipInput) return;

    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculatePajamaSizeWithApproachIfNeeded(breast, waist, hip);

    renderResult('pajamaResult','pajamaEquivalence');
}


function renderResult(resultId, equivalenceId) {
    const openRoot = document.querySelector('.size-guide-panel[data-open-root="true"]');
    const scope = openRoot || document;
    const result = scope.querySelector('#' + resultId) || document.getElementById(resultId);
    const equivalence = scope.querySelector('#' + equivalenceId) || document.getElementById(equivalenceId);
    if (!result || !equivalence) return;

    if (!recommendedSize) {
        result.innerHTML = '<span style="font-size: 20px; font-weight: 500">?</span>';
        equivalence.textContent = '';

        setupAddToCartButton(null);
        return;
    }

    if (resultId === 'shoeResult') {
        if (braRegion === 'es') {
            result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${recommendedSize}</span>`;
            equivalence.innerHTML = '';
            equivalence.classList.remove('visible');
        } else {
            const shoeRegionEq = FIT_GUIDE_EQUIVALENCES_SHOE_REGIONS[recommendedSize];
            if (shoeRegionEq && shoeRegionEq[braRegion]) {
                const label = braRegion === 'eu' ? 'Talla EU' : 'Talla';
                result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${shoeRegionEq[braRegion]}</span>`;
                equivalence.innerHTML = '';
            } else {
                result.textContent = '?';
                equivalence.textContent = '';
            }
        }
    }
    else if (resultId === 'swimPlusResult') {
        if (braRegion === 'es') {
            result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${recommendedSize}</span>`;
            equivalence.innerHTML = '';
            equivalence.classList.remove('visible');
        } else if (braRegion === 'ita') {
            const swimPlusRegionEq = FIT_GUIDE_EQUIVALENCES_SWIM_PLUS_REGIONS[recommendedSize];
            if (swimPlusRegionEq && swimPlusRegionEq[braRegion]) {
                const label = 'Talla ITA';
                result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${swimPlusRegionEq[braRegion]}</span>`;
                equivalence.innerHTML = '';
            } else {
                result.textContent = '?';
                equivalence.textContent = '';
            }
        }
    }
    else if (resultId === 'swimWoCupResult' || resultId === 'bodyWoCupResult') {
        if (braRegion === 'es') {
            result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${recommendedSize}</span>`;
            equivalence.innerHTML = '';
            equivalence.classList.remove('visible');
        } else {
            const swimWoCupRegionEq = FIT_GUIDE_EQUIVALENCES_SWIM_WO_CUP_REGIONS[recommendedSize];
            if (swimWoCupRegionEq && swimWoCupRegionEq[braRegion]) {
                let label;
                switch(braRegion) {
                    case 'es_eu':
                        label = 'Talla EU';
                        break;
                    case 'ita':
                        label = 'Talla ITA';
                        break;
                    case 'fr':
                        label = 'Talla FR';
                        break;
                    case 'uk_us':
                        label = 'Talla US/UK';
                        break;
                    default:
                        label = 'Talla';
                }
                result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${swimWoCupRegionEq[braRegion]}</span>`;
                equivalence.innerHTML = '';
            } else {
                result.textContent = '?';
                equivalence.textContent = '';
            }
        }
    }
    else if (resultId === 'kidsPajamaResult') {
        if (braRegion === 'es') {
            result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${recommendedSize}</span>`;
            equivalence.innerHTML = '';
            equivalence.classList.remove('visible');
        } else {
            const kidsPajamaRegionEq = FIT_GUIDE_EQUIVALENCES_KIDS_PAJAMA_REGIONS[recommendedSize];
            if (kidsPajamaRegionEq && kidsPajamaRegionEq[braRegion]) {
                let label;
                switch(braRegion) {
                    case 'es_eu':
                        label = 'Talla ES/EU';
                        break;
                    case 'ita':
                        label = 'Talla ITA';
                        break;
                    case 'fr':
                        label = 'Talla FR';
                        break;
                    case 'uk_us':
                        label = 'Talla UK/US';
                        break;
                    default:
                        label = 'Talla';
                }
                result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${kidsPajamaRegionEq[braRegion]}</span>`;
                equivalence.innerHTML = '';
            } else {
                result.textContent = '?';
                equivalence.textContent = '';
            }
        }
    }
    else {
        const baseSize = extractNumber(recommendedSize);

        if (braRegion === 'es') {
            result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${recommendedSize}</span>`;

            const eq = FIT_GUIDE_EQUIVALENCES[recommendedSize] || '';
            if (eq) {
                equivalence.innerHTML = `<span style="font-size: 14px; display: block">Equivalente ${eq}</span>`;
                equivalence.classList.add('visible');
            } else {
                equivalence.innerHTML = '';
                equivalence.classList.remove('visible');
            }
        } else {
            const regionEq = FIT_GUIDE_EQUIVALENCES_BODY_REGIONS[baseSize];
            if (regionEq && regionEq[braRegion]) {
                const label = braRegion === 'eur' ? 'Talla EUR' : 'Talla ITA';
                result.innerHTML = `<span style="font-size: 20px; font-weight: 500">${regionEq[braRegion]}</span>`;
                equivalence.innerHTML = '';
            } else {
                result.textContent = '?';
                equivalence.textContent = '';
            }
        }
    }

    setupAddToCartButton(recommendedSize);
}

function setupAddToCartButton(recommendedSize) {
    const addToCartBtn = document.getElementById('size-guide-add-to-cart');
    if (!addToCartBtn) return;

    const errorBox = document.getElementById('size-guide-error');
    if (!errorBox) return;

    const variant = recommendedSize ? window.VARIANTS?.find(v => {
        let variantOption = v.option2?.toLowerCase().trim();
        let recSize = recommendedSize?.toLowerCase().trim();
        
        if (variantOption === recSize) {
            return true;
        }

        if (variantOption && variantOption.includes('/')) {
            let sizes = variantOption.split('/').map(size => size.trim());
            return sizes.includes(recSize);
        }
        
        return false;
    }) : null;

    const textContainer = addToCartBtn.querySelector('.button-label');
    if (!textContainer) return;

    if (!variant) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.backgroundColor = '#E8E8E8';
        addToCartBtn.style.border = '1px solid #E8E8E8';
        textContainer.style.color = '#8D8D86';
        textContainer.textContent = 'AÑADIR A CESTA';
        errorBox.textContent = 'Este artículo no dispone de la talla seleccionada';
        errorBox.classList.add('visible');
    } else if (!variant.available) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.backgroundColor = '#E8E8E8';
        addToCartBtn.style.border = '1px solid #E8E8E8';
        textContainer.textContent = 'AGOTADO';
        textContainer.style.color = '#8D8D86';
        errorBox.textContent = "";
        errorBox.classList.remove('visible');
    } else {
        addToCartBtn.disabled = false;
        textContainer.textContent = 'AÑADIR A CESTA';
        addToCartBtn.style.backgroundColor = '';
        textContainer.style.color = '';
        addToCartBtn.style.border = '';
        errorBox.textContent = "";
        errorBox.classList.remove('visible');
    }
}

function calculateSwimsuiteSize(breast1, breast2)
{
    return calculateBraSizeWithApproachIfNeeded(breast1, breast2);
}

function calculateKnickersSize(waist, hip) {
    if (waist >= 61 && waist < 66) {
        if (hip >= 87 && hip < 92) {
            return 'XS';
        }
    } else if (waist >= 66 && waist < 71) {
        if (hip >= 92 && hip < 97) {
            return 'S';
        }
    } else if (waist >= 71 && waist < 76) {
        if (hip >= 97 && hip < 102) {
            return 'M';
        }
    } else if (waist >= 76 && waist < 81) {
        if (hip >= 102 && hip < 107) {
            return 'L';
        }
    } else if (waist >= 81 && waist < 86) {
        if (hip >= 107 && hip < 113) {
            return 'XL';
        }
    } else if (waist >= 86 && waist <= 100) {
        if (hip >= 113 && hip <= 120) {
            return 'XXL';
        }
    }
    return '';
}

function calculatePajamaSize(breast, waist, hip)
{
    var breastMargin = 2;
    var waistMargin = 4;
    var hipMargin = 8;
    if(breast >= 85 - breastMargin && breast < 90 - breastMargin){
        if(waist >= 68 - waistMargin && waist <= 72) {
            if(hip >= 96 - hipMargin && hip < 100) {
                return 'S';
            }
        }
    } else if(breast >= 90 - breastMargin && breast < 96 - breastMargin){
        if(waist >= 72 - waistMargin && waist <= 78) {
            if(hip >= 100 - hipMargin && hip < 106) {
                return 'M';
            }
        }
    } else if(breast >= 96 - breastMargin && breast < 102 - breastMargin){
        if(waist >= 78 - waistMargin && waist <= 84) {
            if(hip >= 106 - hipMargin && hip < 116) {
                return 'L';
            }
        }
    } else if(breast >= 102 - breastMargin && breast < 110 - breastMargin){
        if(waist >= 84 - waistMargin && waist <= 100) {
            if(hip >= 112 - hipMargin && hip < 120) {
                return 'XL';
            }
        }
    }
    return '';
}

function calculateShortsSize(waist, hip) {
    if (waist >= 64 && waist <= 72) {
        if (hip >= 90 && hip <= 99) {
            return 'S';
        }
    }
    if (waist >= 68 && waist <= 78) {
        if (hip >= 94 && hip <= 105) {
            return 'M';
        }
    }
    if (waist >= 74 && waist <= 84) {
        if (hip >= 100 && hip <= 111) {
            return 'L';
        }
    }
    if (waist >= 80 && waist <= 100) {
        if (hip >= 106 && hip <= 119) {
            return 'XL';
        }
    }
    return '';
}

function calculateShortsSizeWithApproachIfNeeded(waist, hip)
{
    let value = calculateShortsSize(waist, hip);
    let maximumRetries = 50;
    let waistSliderScore = (100 - 64) - (100 - waist);
    let hipSliderScore = (119 - 90) - (119 - hip);
    while(value == '' && maximumRetries > 0) {
        if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateShortsSize(waist, hip);
        maximumRetries--;
    }
    return value;
}

function updateShortsResult() {
    const waistInput = document.getElementById('shortsWaist');
    const hipInput = document.getElementById('shortsHip');

    if (!waistInput || !hipInput) return;
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateShortsSizeWithApproachIfNeeded(waist, hip);

    renderResult('shortsResult','shortsEquivalence');
}



function updateDressResult() {
    const breastInput = document.getElementById('dressBreast');
    const waistInput = document.getElementById('dressWaist');
    const hipInput = document.getElementById('dressHip');

    if (!breastInput || !waistInput || !hipInput) return;

    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);


    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateDressSizeWithApproachIfNeeded(breast, waist, hip);
    renderResult('dressResult','dressEquivalence');
}

function calculateDressSize(breast, waist, hip)
{
    if(breast >= 83 && breast <= 87){
        if(waist >= 64 && waist <= 72) {
            if(hip >= 90 && hip <= 99) {
                return 'S';
            }
        }
    } else if(breast >= 88 && breast <= 93){
        if(waist >= 68 && waist <= 78) {
            if(hip >= 94 && hip <= 105) {
                return 'M';
            }
        }
    } else if(breast >= 94 && breast <= 99){
        if(waist >= 74 && waist <= 84) {
            if(hip >= 100 && hip <= 111) {
                return 'L';
            }
        }
    } else if(breast >= 100 && breast <= 107){
        if(waist >= 80 && waist <= 100) {
            if(hip >= 106 && hip <= 119) {
                return 'XL';
            }
        }
    }
    return '';
}

function calculateManSize(breast, waist, hip)
{
    if(breast >= 100 && breast < 105){
        if(waist >= 80 && waist < 90) {
            if(hip >= 105 && hip < 110) {
                return 'S';
            }
        }
    } else if(breast >= 105 && breast < 110){
        if(waist >= 90 && waist < 100) {
            if(hip >= 110 && hip < 115) {
                return 'M';
            }
        }
    } else if(breast >= 110 && breast < 115){
        if(waist >= 100 && waist < 110) {
            if(hip >= 115 && hip < 120) {
                return 'L';
            }
        }
    } else if(breast >= 115 && breast < 120){
        if(waist >= 110 && waist < 120) {
            if(hip >= 120 && hip < 125) {
                return 'XL';
            }
        }
    }
    return '';
}

function calculatePajamaSizeWithApproachIfNeeded(breast, waist, hip)
{
    let value = calculatePajamaSize(breast, waist, hip);
    let maximumRetries = 200;
    let breastSliderScore = (110 - 85) - (110 - breast);
    let waistSliderScore = (100 - 61) - (100 - waist);
    let hipSliderScore = (120 - 96) - (120 - hip);
    while(value == '' && maximumRetries > 0) {
        if(breastSliderScore > waistSliderScore) {
            waist++;
        } else if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculatePajamaSize(breast, waist, hip);
        maximumRetries--;
    }
    return value;
}

function calculateDressSizeWithApproachIfNeeded(breast, waist, hip)
{
    let value = calculateDressSize(breast, waist, hip);
    let maximumRetries = 200;
    let breastSliderScore = (107 - 83) - (107 - breast);
    let waistSliderScore = (100 - 64) - (100 - waist);
    let hipSliderScore = (119 - 90) - (119 - hip);
    while(value == '' && maximumRetries > 0) {
        if(breastSliderScore > waistSliderScore) {
            waist++;
        } else if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateDressSize(breast, waist, hip);
        maximumRetries--;
    }
    return value;
}

function calculateTShirtSize(breast, waist)
{
    if(breast >= 83 && breast <= 87){
        if(waist >= 64 && waist <= 72) {
            return 'S';
        }
    } else if(breast >= 88 && breast <= 93){
        if(waist >= 68 && waist <= 78) {
            return 'M';
        }
    } else if(breast >= 94 && breast <= 99){
        if(waist >= 74 && waist <= 84) {
            return 'L';
        }
    } else if(breast >= 100 && breast <= 107){
        if(waist >= 80 && waist <= 100) {
            return 'XL';
        }
    }
    return '';
}

function calculateTShirtSizeWithApproachIfNeeded(breast, waist)
{
    let value = calculateTShirtSize(breast, waist);
    let maximumRetries = 200;
    let breastSliderScore = (107 - 83) - (107 - breast);
    let waistSliderScore = (100 - 64) - (100 - waist);
    while(value == '' && maximumRetries > 0) {
        if(breastSliderScore > waistSliderScore) {
            waist++;
        } else {
            waist--;
        }
        value = calculateTShirtSize(breast, waist);
        maximumRetries--;
    }
    return value;
}

function updateRobeResult() {
    const breastInput = document.getElementById('batasBreast');
    const waistInput = document.getElementById('batasWaist');
    const hipInput = document.getElementById('batasHip');

    if (!breastInput || !waistInput || !hipInput) return;
    
    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateDressSizeWithApproachIfNeeded(breast, waist, hip);

    renderResult('batasResult','batasEquivalence');
}

function updateTShirtResult() {
    const breastInput = document.getElementById('tshirtBreast');
    const waistInput = document.getElementById('tshirtWaist');

    if (!breastInput || !waistInput) return;
    
    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);

    recommendedSize = calculateTShirtSizeWithApproachIfNeeded(breast, waist);

    renderResult('tshirtResult','tshirtEquivalence');
}

function calculateShoeSize(footLength) {
    if (footLength >= 23.3 && footLength <= 24.3) {
        return '37/38';
    } else if (footLength >= 24.6 && footLength <= 25.6) {
        return '39/40';
    } else if (footLength >= 25.9 && footLength <= 26.6) {
        return '41/42';
    }
    return '';
}

function calculateShoeSizeWithApproachIfNeeded(footLength) {
    let value = calculateShoeSize(footLength);
    let maximumRetries = 20;
    let retryCount = 0;

    while (value === '' && retryCount < maximumRetries) {
        if (retryCount % 2 === 0) {
            footLength -= 0.1;
        }
        else {
            footLength += 0.2;
        }
        
        value = calculateShoeSize(footLength);
        retryCount++;
    }
    
    return value;
}

function updateShoeResult() {
    const shoeLengthInput = document.getElementById('shoeLength');
    
    if (!shoeLengthInput) return;
    
    const footLength = parseFloat(shoeLengthInput.value);
    
    outputSliderValue(shoeLengthInput, footLength.toFixed(1));
    
    recommendedSize = calculateShoeSizeWithApproachIfNeeded(footLength);
    
    renderResult('shoeResult', 'shoeEquivalence');
}

function changeShoeResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('shoeResult', 'shoeEquivalence');
}

function calculateUnderwearSize(waist, hip) {
    if (waist >= 80 && waist <= 89) {
        if (hip >= 105 && hip <= 109) {
            return 'S';
        }
    }
    if (waist >= 90 && waist <= 99) {
        if (hip >= 110 && hip <= 114) {
            return 'M';
        }
    }
    if (waist >= 100 && waist <= 109) {
        if (hip >= 115 && hip <= 119) {
            return 'L';
        }
    }
    if (waist >= 110 && waist <= 119) {
        if (hip >= 120 && hip <= 124) {
            return 'XL';
        }
    }
    return '';
}

function calculateUnderwearSizeWithApproachIfNeeded(waist, hip) {
    let value = calculateUnderwearSize(waist, hip);
    let maximumRetries = 50;
    let waistSliderScore = (119 - 80) - (119 - waist);
    let hipSliderScore = (124 - 105) - (124 - hip);
    while(value == '' && maximumRetries > 0) {
        if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateUnderwearSize(waist, hip);
        maximumRetries--;
    }
    return value;
}

function updateUnderwearResult() {
    const waistInput = document.getElementById('underwearWaist');
    const hipInput = document.getElementById('underwearHip');

    if (!waistInput || !hipInput) return;
    
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateUnderwearSizeWithApproachIfNeeded(waist, hip);

    renderResult('underwearResult', 'underwearEquivalence');
}

function initSizeGuideAddToCart() {
    let addToCartBtn = document.getElementById('size-guide-add-to-cart');
    let errorBox = document.getElementById('size-guide-error');
    if (!addToCartBtn || !errorBox) return;

    addToCartBtn.addEventListener('click', () => {
        if (!recommendedSize) return;
        const variantId = findVariantIdBySize(recommendedSize);

        if (!variantId) {
            errorBox.textContent = 'Lo sentimos, la talla recomendada no está disponible.';
            errorBox.style.display = 'block';
            return;
        }

        addToCartBtn.classList.add('loading');
        let loader = addToCartBtn.querySelector('.shopify-loader');
        if (loader) {
            loader.removeAttribute('hidden');
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];

        const body = {
            id: variantId,
            quantity: 1,
            sections: sections,
            sections_url: window.location.pathname
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    throw new Error(data.description || 'Error al añadir al carrito.');
                }

                document.body.classList.remove('body-no-scroll');
                const sizeGuidePanel = document.getElementById('size-guide-panel');
                if (sizeGuidePanel) sizeGuidePanel.classList.add('hidden');

                if (cartDrawer) {
                    const drawerInner = cartDrawer.querySelector('.drawer__inner');
                    if (drawerInner) drawerInner.classList.remove('is-empty');
                    cartDrawer.classList.remove('is-empty');

                    if (data.sections) {
                        cartDrawer.renderContents(data);
                    } else {
                        fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
                            .then(response => response.json())
                            .then(sectionsData => {
                                data.sections = sectionsData;
                                cartDrawer.renderContents(data);
                            })
                            .catch(() => {
                                window.location.reload();
                            });
                    }
                } else {
                    window.location = '/cart';
                }
            })
            .catch(err => {
                errorBox.textContent = err.message;
                errorBox.style.display = 'block';
            })
            .finally(() => {
                addToCartBtn.classList.remove('loading');
                if (loader) {
                    loader.setAttribute('hidden', '');
                }
            });

    });
}

function findVariantIdBySize(size) {
    if (!window.VARIANTS || !size) return null;

    const variant = window.VARIANTS.find(v => {
        let variantOption = v.option2?.toLowerCase().trim();
        let sizeToFind = size.toLowerCase().trim();

        if (variantOption === sizeToFind && v.available) {
            return true;
        }

        if (variantOption && variantOption.includes('/') && v.available) {
            let sizes = variantOption.split('/').map(s => s.trim());
            return sizes.includes(sizeToFind);
        }
        
        return false;
    });

    return variant ? variant.id : null;
}

function calculateSwimPlusSize(breast, waist, hip)
{
    if(breast >= 100 && breast <= 104){
        if(waist >= 82 && waist <= 86) {
            if(hip >= 106 && hip <= 110) {
                return '42';
            }
        }
    } else if(breast >= 104 && breast <= 108){
        if(waist >= 86 && waist <= 90) {
            if(hip >= 110 && hip <= 114) {
                return '44';
            }
        }
    } else if(breast >= 108 && breast <= 112){
        if(waist >= 90 && waist <= 94) {
            if(hip >= 114 && hip <= 118) {
                return '46';
            }
        }
    } else if(breast >= 112 && breast <= 116){
        if(waist >= 94 && waist <= 98) {
            if(hip >= 118 && hip <= 122) {
                return '48';
            }
        }
    } else if(breast >= 116 && breast <= 122){
        if(waist >= 98 && waist <= 104) {
            if(hip >= 122 && hip <= 128) {
                return '50';
            }
        }
    } else if(breast >= 122 && breast <= 128){
        if(waist >= 104 && waist <= 110) {
            if(hip >= 128 && hip <= 134) {
                return '52';
            }
        }
    }
    return '';
}

function calculateSwimPlusSizeWithApproachIfNeeded(breast, waist, hip)
{
    let value = calculateSwimPlusSize(breast, waist, hip);
    let maximumRetries = 200;
    let breastSliderScore = (128 - 100) - (128 - breast);
    let waistSliderScore = (110 - 82) - (110 - waist);
    let hipSliderScore = (134 - 106) - (134 - hip);
    while(value == '' && maximumRetries > 0) {
        if(breastSliderScore > waistSliderScore) {
            waist++;
        } else if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateSwimPlusSize(breast, waist, hip);
        maximumRetries--;
    }
    return value;
}

function updateSwimPlusResult() {
    const breastInput = document.getElementById('swimPlusBreast');
    const waistInput = document.getElementById('swimPlusWaist');
    const hipInput = document.getElementById('swimPlusHip');

    if (!breastInput || !waistInput || !hipInput) return;
    
    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateSwimPlusSizeWithApproachIfNeeded(breast, waist, hip);

    renderResult('swimPlusResult','swimPlusEquivalence');
}

function changeSwimPlusResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('swimPlusResult','swimPlusEquivalence');
}

function calculateMenPajamaSize(breast, waist, hip)
{
    if(breast >= 100 && breast <= 104){
        if(waist >= 80 && waist <= 89) {
            if(hip >= 105 && hip <= 109) {
                return 'S';
            }
        }
    } else if(breast >= 105 && breast <= 109){
        if(waist >= 90 && waist <= 99) {
            if(hip >= 110 && hip <= 114) {
                return 'M';
            }
        }
    } else if(breast >= 110 && breast <= 114){
        if(waist >= 100 && waist <= 109) {
            if(hip >= 115 && hip <= 119) {
                return 'L';
            }
        }
    } else if(breast >= 115 && breast <= 119){
        if(waist >= 110 && waist <= 119) {
            if(hip >= 120 && hip <= 124) {
                return 'XL';
            }
        }
    } else if(breast >= 120 && breast <= 126){
        if(waist >= 120 && waist <= 126) {
            if(hip >= 125 && hip <= 130) {
                return 'XXL';
            }
        }
    }
    return '';
}

function calculateMenPajamaSizeWithApproachIfNeeded(breast, waist, hip)
{
    let value = calculateMenPajamaSize(breast, waist, hip);
    let maximumRetries = 200;
    let breastSliderScore = (126 - 100) - (126 - breast);
    let waistSliderScore = (126 - 80) - (126 - waist);
    let hipSliderScore = (130 - 105) - (130 - hip);
    while(value == '' && maximumRetries > 0) {
        if(breastSliderScore > waistSliderScore) {
            waist++;
        } else if(waistSliderScore > hipSliderScore) {
            waist--;
        } else {
            hip++;
        }
        value = calculateMenPajamaSize(breast, waist, hip);
        maximumRetries--;
    }
    return value;
}

function updateMenPajamaResult() {
    const breastInput = document.getElementById('menPajamasBreast');
    const waistInput = document.getElementById('menPajamasWaist');
    const hipInput = document.getElementById('menPajamasHip');

    if (!breastInput || !waistInput || !hipInput) return;
    
    const breast = parseInt(breastInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);

    outputSliderValue(breastInput, breast);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);

    recommendedSize = calculateMenPajamaSizeWithApproachIfNeeded(breast, waist, hip);

    renderResult('menPajamaResult','menPajamaEquivalence');
}

function calculateKidsPajamaSize(height, chest, waist, hip) {
    if (height >= 104 && height <= 110 && 
        chest >= 56 && chest <= 59 && 
        waist >= 53 && waist <= 55 && 
        hip >= 60 && hip <= 62) {
        return '4-5';
    }

    if (height >= 116 && height <= 122 && 
        chest >= 59 && chest <= 63 && 
        waist >= 55 && waist <= 57 && 
        hip >= 62 && hip <= 66) {
        return '6-7';
    }

    if (height >= 128 && height <= 134 && 
        chest >= 63 && chest <= 67 && 
        waist >= 57 && waist <= 59 && 
        hip >= 66 && hip <= 70) {
        return '8-9';
    }

    if (height >= 140 && height <= 146 && 
        chest >= 67 && chest <= 73 && 
        waist >= 59 && waist <= 61 && 
        hip >= 70 && hip <= 76) {
        return '10-11';
    }

    if (height >= 152 && height <= 158 && 
        chest >= 73 && chest <= 79 && 
        waist >= 61 && waist <= 64 && 
        hip >= 76 && hip <= 82) {
        return '12-13';
    }

    if (height >= 104 && height <= 110) {
        return '4-5';
    } else if (height >= 111 && height <= 122) {
        return '6-7';
    } else if (height >= 123 && height <= 134) {
        return '8-9';
    } else if (height >= 135 && height <= 146) {
        return '10-11';
    } else if (height >= 147 && height <= 158) {
        return '12-13';
    }
    
    return '';
}

function calculateKidsPajamaSizeWithApproachIfNeeded(height, chest, waist, hip) {
    let value = calculateKidsPajamaSize(height, chest, waist, hip);
    let maximumRetries = 20;

    while (value === '' && maximumRetries > 0) {
        if (maximumRetries % 4 === 0) {
            height = Math.max(104, Math.min(158, height + (maximumRetries > 10 ? -1 : 1)));
        } else if (maximumRetries % 4 === 1) {
            chest = Math.max(56, Math.min(79, chest + (maximumRetries > 10 ? -1 : 1)));
        } else if (maximumRetries % 4 === 2) {
            waist = Math.max(53, Math.min(64, waist + (maximumRetries > 10 ? -1 : 1)));
        } else {
            hip = Math.max(60, Math.min(82, hip + (maximumRetries > 10 ? -1 : 1)));
        }
        
        value = calculateKidsPajamaSize(height, chest, waist, hip);
        maximumRetries--;
    }

    if (value === '') {
        if (height >= 104 && height <= 110) {
            return '4-5';
        } else if (height >= 111 && height <= 122) {
            return '6-7';
        } else if (height >= 123 && height <= 134) {
            return '8-9';
        } else if (height >= 135 && height <= 146) {
            return '10-11';
        } else if (height >= 147 && height <= 158) {
            return '12-13';
        }

        if (height < 104) {
            return '4-5';
        } else {
            return '12-13';
        }
    }
    
    return value;
}

function updateKidsPajamaResult() {
    const heightInput = document.getElementById('kidsPajamaHeight');
    const chestInput = document.getElementById('kidsPajamaChest');
    const waistInput = document.getElementById('kidsPajamaWaist');
    const hipInput = document.getElementById('kidsPajamaHip');
    
    if (!heightInput || !chestInput || !waistInput || !hipInput) return;
    
    const height = parseInt(heightInput.value, 10);
    const chest = parseInt(chestInput.value, 10);
    const waist = parseInt(waistInput.value, 10);
    const hip = parseInt(hipInput.value, 10);
    
    outputSliderValue(heightInput, height);
    outputSliderValue(chestInput, chest);
    outputSliderValue(waistInput, waist);
    outputSliderValue(hipInput, hip);
    
    recommendedSize = calculateKidsPajamaSizeWithApproachIfNeeded(height, chest, waist, hip);
    renderResult('kidsPajamaResult', 'kidsPajamaEquivalence');

}
function changeKidsPajamaResultRegion(region) {
    braRegion = region;
    document.querySelectorAll('.region-btn').forEach(btn => {
        btn.classList.toggle('region-selected', btn.dataset.region === region);
    });
    renderResult('kidsPajamaResult', 'kidsPajamaEquivalence');
}

function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
    } else {
        document.querySelector('[data-cart-toggle]')?.click();
    }
}